import React from 'react';

const SubmissionConfirmation = ({ form, theme }) => {
    const confirmationStyle = {
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        background: theme?.backgroundImageUrl 
            ? `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url(${theme.backgroundImageUrl})`
            : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        fontFamily: theme?.fontFamily || 'system-ui, -apple-system, sans-serif'
    };

    const cardStyle = {
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '3rem',
        maxWidth: '600px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)'
    };

    const logoStyle = {
        maxWidth: '200px',
        maxHeight: '80px',
        marginBottom: '2rem',
        objectFit: 'contain'
    };

    const titleStyle = {
        fontSize: '2.5rem',
        fontWeight: '700',
        color: theme?.primaryColor || '#1f2937',
        marginBottom: '1rem',
        lineHeight: '1.2'
    };

    const subtitleStyle = {
        fontSize: '1.25rem',
        color: '#6b7280',
        marginBottom: '2rem',
        lineHeight: '1.5'
    };

    const messageStyle = {
        fontSize: '1.1rem',
        color: '#374151',
        marginBottom: '2rem',
        lineHeight: '1.6'
    };

    const buttonStyle = {
        backgroundColor: theme?.primaryColor || '#F27200',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        padding: '1rem 2rem',
        fontSize: '1.1rem',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        textDecoration: 'none',
        display: 'inline-block'
    };

    return (
        <div style={confirmationStyle}>
            <div style={cardStyle}>
                {theme?.logoUrl && (
                    <img 
                        src={theme.logoUrl} 
                        alt="Company Logo" 
                        style={logoStyle}
                    />
                )}
                
                <h1 style={titleStyle}>
                    Thank You!
                </h1>
                
                <h2 style={subtitleStyle}>
                    Your form has been submitted successfully
                </h2>
                
                <p style={messageStyle}>
                    We've received your submission and will get back to you as soon as possible. 
                    Thank you for taking the time to fill out our form.
                </p>
                
                <div style={{ marginTop: '2rem' }}>
                    {form?.businessWebsite ? (
                        <a 
                            href={form.businessWebsite} 
                            style={buttonStyle}
                            onMouseOver={(e) => {
                                e.target.style.backgroundColor = theme?.secondaryColor || '#e55a00';
                                e.target.style.transform = 'translateY(-2px)';
                            }}
                            onMouseOut={(e) => {
                                e.target.style.backgroundColor = theme?.primaryColor || '#F27200';
                                e.target.style.transform = 'translateY(0)';
                            }}
                        >
                            Visit Our Website
                        </a>
                    ) : (
                        <button 
                            style={buttonStyle}
                            onClick={() => window.location.reload()}
                            onMouseOver={(e) => {
                                e.target.style.backgroundColor = theme?.secondaryColor || '#e55a00';
                                e.target.style.transform = 'translateY(-2px)';
                            }}
                            onMouseOut={(e) => {
                                e.target.style.backgroundColor = theme?.primaryColor || '#F27200';
                                e.target.style.transform = 'translateY(0)';
                            }}
                        >
                            Submit Another Form
                        </button>
                    )}
                </div>
                
                <div style={{ 
                    marginTop: '2rem', 
                    fontSize: '0.9rem', 
                    color: '#9ca3af' 
                }}>
                    <p>Form: {form?.title || 'Contact Form'}</p>
                    <p>Submitted on: {new Date().toLocaleDateString()}</p>
                </div>
            </div>
        </div>
    );
};

export default SubmissionConfirmation;
